// Keep Thai letters, vowel/tone marks and digits in uploaded/downloaded names.
// Replace path separators and unsupported filename characters without changing extensions.
export const safeMedicalCertificateFileName = (name = "file") =>
  String(name).replace(/[^a-zA-Z0-9._\u0E00-\u0E7F-]/g, "_") || "file";
